import { useTranslation } from 'react-i18next'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@clouway/ui'

import { useVendorModels } from '../hooks'

export function VendorModelSelector({
  vendorId,
  value,
  onChange,
}: {
  vendorId?: string
  value?: string
  onChange: (value: string) => void
}) {
  const { t } = useTranslation('feature')
  const { data: models = [] } = useVendorModels(vendorId ?? '')

  return (
    <Select value={value} onValueChange={onChange} disabled={!vendorId}>
      <SelectTrigger aria-label={t('trackingObjects.activationForm.deviceModel')}>
        <SelectValue placeholder={t('vendor.select.placeholder')} />
      </SelectTrigger>
      <SelectContent>
        {models.map((model) => (
          <SelectItem key={model.id} value={model.id}>
            {model.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
